import VehicleUnavailabilityFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => (
  <GenericEditForm formLayoutComponent={<VehicleUnavailabilityFormLayout />} transformValues={transformValues} />
)
